
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';

class Plan {
    constructor(obj){
        Object.assign(this, obj)
    }
}
class ConfigurationElement {
    constructor(obj){
        Object.assign(this, obj)
    }
}

class BillingAPI extends API {

    url() {
        return config.get("re.url");
    }

    urlGlobal() {
        return config.get("re.urlGlobal");
    }

    // Add a new configuration element.
    createConfigurationElement(element){
        return new Promise((resolve, reject) => {

            const body = {
                        'action': 'create-element',
                        'element': element,
                        "related-element" : null
            }
            
            axios.post(
                this.urlGlobal() + "billing/admin/elements",
                JSON.stringify(body),
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 300) {

                    resolve(new ConfigurationElement(response.data.user));
                } 
                else {
                    const err = new Error(response.status, "Something went wrong when trying to create a configuration element", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                // if (err.response && err.response.status === 303){
                //     const handleError = new Error(err.response.status, "Username already exist", "Username already exist");
                //     reject(handleError);
                // } else {
                    reject(err);
                // }                    
            });
        });
    }

    // Delete a configuration element.
    deleteConfigurationElement(elementId){
        return new Promise((resolve, reject) => {

            const body = {
                        'action': 'delete-element',
                        "element": {
                            "id": elementId,
                            "deleted_at": "**TODAY-MIDNIGHT**"
                        },
                        "related-element": null
            }
            
            axios.post(
                this.urlGlobal() + "billing/admin/elements",
                JSON.stringify(body),
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 300) {

                    resolve(new ConfigurationElement(response.data.user));
                } 
                else {
                    const err = new Error(response.status, "Something went wrong when trying to delete a configuration element", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);        
            });
        });
    }

    

    // Configuration items are the most atomic unit of configuration for the costs of a resource and its lifetime.
    getConfigurationElements() {
        return new Promise((resolve, reject) => {

            axios.get(
                // this.url() + "/snx_billing_plan_base?id_plan=" + Number(idPlan),
                this.urlGlobal() + "billing/plans/config/elements",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(response.data.elements);
                } else {
                    const err = new Error(response.status, "Failed to fetch configuration elements", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // Retrive configuration element given its ID.
    getConfigurationElementById(id){
        return new Promise((resolve, reject) => {
            
            const body = {
                "action": "get-element",
                "element": {
                    "id": id
                },
                "related-element": null
                
            };

            axios.post(
                this.urlGlobal() + "billing/admin/elements",
                JSON.stringify(body),
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {

                    resolve(response.data.result);
                } else {
                    const err = new Error(response.status, "Failed to fetch configuration element by Id", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }
    
    // Retrive configuration element given a plan id.
    // getConfigurationElementsByPlanId(id) {
        // return new Promise((resolve, reject) => {
        //     axios.get(
        //         // this.url() + "/snx_billing_plan_base?id_plan=" + Number(idPlan),
        //         this.urlGlobal() + "billing/plans/config/elements",
        //       this._getHeaders(),

        //     ).then(response => {
        //         if (response.status === 200) {

        //             resolve(response.data.elements);
        //         } else {
        //             const err = new Error(response.status, "Failed to fetch configuration elements", JSON.stringify(response.data));
        //             reject(err);
        //         }

        //     }).catch(err => {
        //         reject(err);
        //     });
        // })
    // }

    // Retrieve a Commercial Plan given its ID.
    getCommercialPlanById(idPlan) {
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlGlobal() + "billing/plans/"+idPlan+"/config",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to fetch commercial plan by id", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }    

    // Get Billing Plans https://gitlab.com/singularmentor/ecu/-/wikis/Sinexiar-Modelo-de-Facturaci%C3%B3n#billing_plan
    getBillingPlan() {
        return new Promise((resolve, reject) => {
            axios.get(
                this.url() + "/billing_plan",
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    // resolve(response.data.billing_plan);

                    const plans = [];
                    response.data.billing_plan.forEach(p => {
                        plans.push(p);
                    });
                    resolve(plans);

                } else {
                    const err = new Error(response.status, "Failed to fetch standar commercial plans", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // Return all commercial plans configuration
    getSnxBillingPlanBase() {
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlGlobal() + "billing/plans",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    // resolve(response.data.snx_billing_plan_base);
                    resolve(response.data.plans);
                } else {
                    const err = new Error(response.status, "Failed to fetch detailed plan configuration", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // To facilitate access to the configuration information of a BASE Commercial Plan, the view 'snx_billing_plan_base' is available, which returns the denormalized information of the plan.
    // https://gitlab.com/singularmentor/ecu/-/wikis/Sinexiar-Modelo-de-Facturaci%C3%B3n#vista-snx_billing_plan_base
    // getSnxBillingPlanBaseById(idPlan) {
    //     return new Promise((resolve, reject) => {
    //         axios.get(
    //             // this.url() + "/snx_billing_plan_base?id_plan=" + Number(idPlan),
    //             this.urlGlobal() + "billing/plans?id=" + Number(idPlan),
    //           this._getHeaders(),

    //         ).then(response => {
    //             if (response.status === 200) {
    //                 resolve(response.data.plans);
    //             } else {
    //                 const err = new Error(response.status, "Failed to fetch detailed plan configuration by id", JSON.stringify(response.data));
    //                 reject(err);
    //             }

    //         }).catch(err => {
    //             reject(err);
    //         });
    //     })
    // }

    // Commercial plans https://gitlab.com/singularmentor/ecu/-/wikis/API-Facturaci%C3%B3n-Sinexiar#lista-de-planes-comerciales-sinexiar
    getBillingPlanAccounts(){
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlGlobal() + "billing/accounts/plans",
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {

                    const plans = [];
                    response.data.accounts_plans.forEach(p => {
                        plans.push(p);
                    });
                    resolve(plans);

                } else {
                    const err = new Error(response.status, "Failed to fetch Billing plan Accounts", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // Billing Account Plan https://gitlab.com/singularmentor/ecu/-/wikis/Sinexiar-Modelo-de-Facturaci%C3%B3n#vista-snx_billing_account_plan
    getSnxBillingAccountPlanById(account_id){
        return new Promise((resolve, reject) => {
            axios.get(
                this.url() + "snx_billing_account_plan?account_id=" + account_id,
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {

                    const plans = [];
                    response.data.snx_billing_account_plan.forEach(p => {
                        plans.push(p);
                    });
                    resolve(plans);

                } else {
                    const err = new Error(response.status, "Failed to fetch Billing Account Plan By Id", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    // Create a Plan
    createPlan (plan) {

        // TODO: Create function
        return null;
    }
    
    // Update a Plan
    updatePlan (plan) {

        // TODO: Update function
        return null;
    }
    
}

export {
    BillingAPI, Plan, ConfigurationElement
};